module.exports = __webpack_public_path__ + "static/media/logo.907fba74.png";